module.exports = __webpack_public_path__ + "static/media/Delete.a0622927.svg";